export { default as IntegrationDetail } from "./IntegrationDetail";
